import toast from "react-hot-toast";

const notify = (msg: string, type: string) => toast(msg, { duration: 4000, position: "top-right", style: { background: "#363636", color: "#fff" }, iconTheme: { primary: type === "error" ? "red" : "green", secondary: "#FFFAEE", }, });

export const errorHandler = (err: any): { data?: any; error: any; } => {
	if (!err.response) {
		const error = err.message || "Erreur de connexion au serveur";
		notify(error, "error");
		return { error };
	}
	const error = err.response.data?.message || err.response.data?.error || "Une erreur est survenue";
	notify(error, "error");
	return { error };
}
